/* angular:styles/component:css;a805fd2ce404c100759136a1738d403fac004ae72c99b1101a069928d272b51b;/src/src/app/shared/components/formly/formly-checkbox-with-button/formly-checkbox-with-button.ts */
.custom-item {
  padding-top: 50px;
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}
.button-with-icon {
  padding-left: 5%;
  font-size: small;
}
.checkbox-label {
  margin-left: 8px;
  font-size: 1rem;
  text-align: left;
}
@media (max-width: 768px) {
  .custom-item {
    padding-top: 20px;
    flex-direction: row;
    justify-content: space-between;
    gap: 0.5rem;
  }
  .button-with-icon {
    text-align: center;
  }
  .checkbox-label {
    margin-left: 8px;
    text-align: left;
  }
}
/*# sourceMappingURL=formly-checkbox-with-button.css.map */
